import { retry } from 'services/utilityService';

import { apiGetAccountUsers } from './apiGetAccountUsers';

/**
 * Fetches all account users with automatic retry/backoff on transient failures.
 *
 * This endpoint has no Cloud `status` in its body, so success is detected by the presence of a
 * `Users` array (custom `isSuccess`). On terminal failure `retry` rejects, so the caller can surface
 * an error / fall back.
 *
 * @returns {Promise<Array<Object>>} The account users (`response.data.Users`).
 * @throws {Error} If the request ultimately fails.
 */
export const getAccountUsersWithRetry = async () => {
    const response = await retry(() => apiGetAccountUsers(), {
        isSuccess: (res) => Array.isArray(res?.data?.Users),
    });

    return response.data.Users;
};
